import { Destructable } from "./types";
import { addDependency } from "./utils";
import DestructableSet from "./DestructableSet";

export default class DestructorSet<V extends Destructable> extends DestructableSet<V> {
	add(value: V): this {
		if (value.destroyed) return this;
		if (!this.has(value)) {
			addDependency(this, value, () => {
				this.delete(value);
			});
		}
		return super.add(value);
	}
}
